import gql from 'graphql-tag';

import type { PartialBlog } from 'src/data/blog';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryBlogSectionsContentArgs } from 'src/types/backend';

const QUERY = gql`
  query BlogSectionsContent($projectId: ID!, $draftId: ID!) {
    blogSectionsContent(projectId: $projectId, draftId: $draftId) {
      status
      text
      headline
      sectionId
      errorMessage
    }
  }
`;

type Variables = BackendQueryBlogSectionsContentArgs;

export const queryBlogSectionsContent = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<PartialBlog>(result.data);
};
